import { render, staticRenderFns } from "./FormLoginPatient.vue?vue&type=template&id=5302f35e&scoped=true"
import script from "./FormLoginPatient.vue?vue&type=script&lang=js"
export * from "./FormLoginPatient.vue?vue&type=script&lang=js"
import style0 from "./FormLoginPatient.vue?vue&type=style&index=0&id=5302f35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5302f35e",
  null
  
)

export default component.exports